/**
 * Copyright 2014 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { __extends } from "tslib";
import { AVM1Object } from '../runtime/AVM1Object';
import { wrapAVM1NativeClass } from './AVM1Utils';
import { AVM1Matrix, toAS3Matrix } from './AVM1Matrix';
import { AVM1ColorTransform, toAwayColorTransform } from './AVM1ColorTransform';
import { AVM1Rectangle } from './AVM1Rectangle';
var AVM1Transform = /** @class */ (function (_super) {
    __extends(AVM1Transform, _super);
    function AVM1Transform() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AVM1Transform.createAVM1Class = function (context) {
        return wrapAVM1NativeClass(context, true, AVM1Transform, [], ['matrix#', 'concatenatedMatrix#', 'colorTransform#', 'pixelBounds#'], null, AVM1Transform.prototype.avm1Constructor);
    };
    Object.defineProperty(AVM1Transform.prototype, "as3Transform", {
        get: function () {
            return this._targetAwayObject.transform;
        },
        enumerable: true,
        configurable: true
    });
    AVM1Transform.prototype.avm1Constructor = function (target_mc) {
        this._target = this.context.resolveTarget(target_mc);
        this._targetAwayObject = this._target.adaptee;
    };
    AVM1Transform.prototype.getMatrix = function () {
        var transform = this._targetAwayObject.transform;
        return AVM1Matrix.fromAS3Matrix(this.context, transform.matrix);
    };
    AVM1Transform.prototype.setMatrix = function (value) {
        var transform = this._targetAwayObject.transform;
        transform.matrix = toAS3Matrix(value);
    };
    AVM1Transform.prototype.getConcatenatedMatrix = function () {
        console.log('[AVM1Transform] concatenatedMatrix not implemented');
        return null;
        //return AVM1Matrix.fromAS3Matrix(this.context, <Matrix>transform.concatenatedMatrix);
    };
    AVM1Transform.prototype.getColorTransform = function () {
        var transform = this._targetAwayObject.transform;
        return AVM1ColorTransform.fromAwayColorTransform(this.context, transform.colorTransform);
    };
    AVM1Transform.prototype.setColorTransform = function (value) {
        var transform = this._targetAwayObject.transform;
        transform.colorTransform = toAwayColorTransform(value);
    };
    AVM1Transform.prototype.getPixelBounds = function () {
        var transform = this._targetAwayObject.transform;
        return AVM1Rectangle.fromAS3Rectangle(this.context, transform.pixelBounds);
    };
    return AVM1Transform;
}(AVM1Object));
export { AVM1Transform };
